import { render, staticRenderFns } from "./AllUsersRightSidebar.vue?vue&type=template&id=20e48c7b&scoped=true&"
import script from "./AllUsersRightSidebar.vue?vue&type=script&lang=ts&"
export * from "./AllUsersRightSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./AllUsersRightSidebar.vue?vue&type=style&index=0&id=20e48c7b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e48c7b",
  null
  
)

export default component.exports